import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { debounce } from 'lodash';
import { Map } from 'immutable';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import React from 'react';
import swal from 'sweetalert2';
import { change } from 'redux-form';
import styled from 'styled-components';
import 'cropperjs/dist/cropper.css';
import { Button, /* SearchInput, */ Tab, Tabs } from '../_common';
import { MediaGalleryConstants } from '../../constants';
import { BusinessActions, CampaignActions, MediaActions } from '../../_redux';
import { getImageMeta } from '../../_core/utils';
import HostedMedias from './HostedMedias';
import MyMedias from './MyMedias';
import WebMedias from './WebMedias';
import Footer from './Footer';
import ImageCropper from './ImageCropper';
import '../../styles/modal.scss';
import './gallery.scss';
import '../../components/_common/button.scss';
import NoMobile from '../../icons/no_mobile.svg';
// import {CROP_RATE, MEDIA_TYPE} from '../../constants/mediaGallery';

const ViewBody = styled.div`
  display: ${props => (props.hide ? 'none' : 'block')};
  height: 450px;
  background: #fff;
`;

const mapStateToProps = state => {
  const id = state.business.get('businessDetails').get('business');
  return {
    // medias: state.media.get('medias').toList().toJS(),
    business_id: id && id.get && id.get('id'),
    medias: state.media.get(`${MediaGalleryConstants.MEDIA_FROM.hosted}`).toList().toJS(),
    web_media_page: state.media.get('web_media_page'),
    activeTab: state.media.get('activeTab'),
    selection: state.media.get('selection'),
    isOpen: state.media.get('open'),
    isMobile: state.general.get('isMobile'),
    uploading: state.media.get('uploading'),
    uploadingCropped: state.media.get('uploadingCropped'),
    crop: state.media.get('crop'),
    cropObject: state.media.get('cropObject'),
    web_media_query: state.media.get('query'),
    galleryState: state.media.get('galleryState'),
  };
};

const ImageFields = {
  cover: 'cover_media',
  profile: 'profile_media',
  campaign_preview_media_url: 'preview_media',
  campaign_token_symbol_media_url: 'token_image_media',
  create_token: 'token_media',
};
const ImageInterface = [
  'id', 'url', 'type', 'x1', 'y1', 'x2', 'y2',
];


const mapDispatchToProps = {
  DELETE_MEDIA: MediaActions.DELETE_MEDIA,
  REMOVE_MEDIA: MediaActions.REMOVE_MEDIA,
  CHANGE_MEDIA: MediaActions.CHANGE_MEDIA,
  UPDATE_MEDIA: MediaActions.UPDATE_MEDIA,
  SEARCH_WEB_MEDIAS: MediaActions.SEARCH_WEB_MEDIAS,
  UPDATE_BUSINESS_INFO: BusinessActions.UPDATE_BUSINESS_INFO,
  UPLOAD_MEDIA: MediaActions.UPLOAD_MEDIA,
  SET_MEDIA_TAB: MediaActions.SET_MEDIA_TAB,
  SET_MEDIA_SELECTION: MediaActions.SET_MEDIA_SELECTION,
  SET_MEDIA_CROP: MediaActions.SET_MEDIA_CROP,
  SET_MEDIA_CROPPED_IMAGE: MediaActions.SET_MEDIA_CROPPED_IMAGE,
  UPDATE_THUMB_CROP_URLS: MediaActions.UPDATE_THUMB_CROP_URLS,
  SET_GALLERY_STATE: MediaActions.SET_GALLERY_STATE,
  UPDATE_CAMPAIGN_FORM_FIELD: CampaignActions.UPDATE_CAMPAIGN_FORM_FIELD,
  CHANGE_FORM: change,
};

class MediaGalleryModal extends React.Component {
  static propTypes = {
    galleryState: PropTypes.instanceOf(Map),
    isOpen: PropTypes.bool,
    isMobile: PropTypes.bool,
    parent: PropTypes.string,
    // isCropMode: PropTypes.bool,
    uploading: PropTypes.bool,
    uploadingCropped: PropTypes.bool,
    // imageField: PropTypes.string,
    activeTab: PropTypes.number,
    web_media_page: PropTypes.number,
    business_id: PropTypes.number,
    // cropImage: PropTypes.object,
    crop: PropTypes.object,
    cropObject: PropTypes.object,
    selection: PropTypes.object,
    intl: PropTypes.object,
    medias: PropTypes.array,
    web_media_query: PropTypes.string,
    // onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func,
    CHANGE_MEDIA: PropTypes.func.isRequired,
    UPDATE_MEDIA: PropTypes.func.isRequired,
    REMOVE_MEDIA: PropTypes.func.isRequired,
    DELETE_MEDIA: PropTypes.func.isRequired,
    SEARCH_WEB_MEDIAS: PropTypes.func.isRequired,
    UPLOAD_MEDIA: PropTypes.func.isRequired,
    SET_MEDIA_TAB: PropTypes.func.isRequired,
    SET_MEDIA_SELECTION: PropTypes.func.isRequired,
    SET_MEDIA_CROP: PropTypes.func.isRequired,
    SET_MEDIA_CROPPED_IMAGE: PropTypes.func.isRequired,
    UPDATE_THUMB_CROP_URLS: PropTypes.func.isRequired,
    UPDATE_CAMPAIGN_FORM_FIELD: PropTypes.func.isRequired,
    CHANGE_FORM: PropTypes.func.isRequired,
    UPDATE_BUSINESS_INFO: PropTypes.func.isRequired,
    SET_GALLERY_STATE: PropTypes.func.isRequired,
  }

  static defaultProps = {
    web_media_query: '',
    parent: 'app',
  }

  state = {
    web_media_query: this.props.web_media_query,
    searchInputValue: this.props.web_media_query || '',
  }

  componentDidUpdate(prevProps) {
    const { activeTab, galleryState } = this.props;
    if (this.props.isOpen && !prevProps.isOpen && this.props.galleryState.get('isCropMode')) {
      console.log('CROP', galleryState.get('imageField'), galleryState.get('cropImage'));
      // getImageMeta(cropImage.url).then(({ width, height }) => {
      const crop = {
        image: galleryState.get('cropImage').toJS(), // { ...galleryState.get('cropImage') /* , width, height */},
        on: activeTab,
        rate: MediaGalleryConstants.CONTEXT_CROP_RATE[galleryState.get('imageField')]
          || MediaGalleryConstants.CROP_RATE.Logo,
      };
      this.props.SET_MEDIA_CROP(crop);
      // });
    }
    if (this.props.isOpen && !prevProps.isOpen) {
      console.log(
        galleryState.get('imageField'),
        MediaGalleryConstants.ALLOWED_MEDIA_TYPES[galleryState.get('imageField')]
      );
    }
  }

  onCancel = () => {
    const {
      activeTab, crop, SET_MEDIA_CROP, SET_MEDIA_CROPPED_IMAGE, SET_GALLERY_STATE,
    } = this.props;
    if (crop.on === activeTab && !this.props.galleryState.get('isCropMode')) {
      SET_MEDIA_CROP({});
      SET_MEDIA_CROPPED_IMAGE({});
      return;
    }

    SET_GALLERY_STATE({ active: false });
  }

  onKeyDownSearchInput = e => {
    if (e.key === 'Enter' && this.searchInput) {
      this.searchInput.blur();
    }
  }

  onBlurSearchInput = () => {
    this.onSearchSubmit(this.state.searchInputValue);
  }

  onChangeSearchInput = e => {
    this.setState({ searchInputValue: e.target.value });
  }

  onConfirm = async() => {
    const {
      galleryState, crop, activeTab, // imageField,
    } = this.props;

    if (crop.on === activeTab) {
      // console.log('Cropped data', this.cropper.getData())

      const {
        cropObject, UPDATE_THUMB_CROP_URLS, business_id, SET_GALLERY_STATE,
      } = this.props;
      const {
        x, y, width, height,
      } = (!cropObject || Number.isNaN(cropObject.x) || Number.isNaN(cropObject.y)
        || Number.isNaN(cropObject.width) || Number.isNaN(cropObject.height))
        ? this.cropper.getData(true)
        : cropObject;
      let media = Object.assign({ ...crop.image }, {
        x1: Math.round(x), y1: Math.round(y), x2: Math.round(x + width), y2: Math.round(y + height),
      });

      if (galleryState.get('isCropMode')) {
        const cropped = {
          ...crop.image,
          x1: Math.round(cropObject.x),
          y1: Math.round(cropObject.y),
          x2: Math.round(cropObject.x) + Math.round(cropObject.width),
          y2: Math.round(cropObject.y) + Math.round(cropObject.height),
        };
        this.updateInfo(cropped);
        SET_GALLERY_STATE({ active: false });
        return;
      }

      const newMedia = Number.isNaN(parseInt(media.id, 10));

      console.log('IS_NEW_MEDIA', newMedia);

      if (newMedia) {
        const { UPLOAD_MEDIA } = this.props;
        const {
          url: web_url, x1, x2, y1, y2,
        } = media;
        UPLOAD_MEDIA({
          body: {
            business_id, web_url, x1, x2, y1, y2,
          },
          media,
          from: activeTab,
        }, galleryState.get('imageField'));
      } else {
        const {
          CHANGE_MEDIA, UPDATE_MEDIA, SET_MEDIA_CROP, SET_MEDIA_SELECTION,
        } = this.props;
        Promise.resolve(CHANGE_MEDIA(media, activeTab))
          .then(async() => {
            if (activeTab === MediaGalleryConstants.MEDIA_FROM.web) {
              this.setSelection(media.id, activeTab);
            } else if (!galleryState.get('isCropMode')) {
              const croppedBlob = await new Promise(resolve => {
                this.cropper.getCroppedCanvas().toBlob(resolve, 'image/jpeg');
              });
              SET_MEDIA_CROP({});
              const { media: updatedMedia } = await UPDATE_THUMB_CROP_URLS(media, croppedBlob, business_id, activeTab);
              media = updatedMedia;
              SET_MEDIA_SELECTION({ media, on: activeTab });
            } else {
              SET_MEDIA_CROP({});
              Promise.resolve(UPDATE_MEDIA(media.id, media, activeTab))
                .then(cropResult => {
                  console.log('CROPPED', cropResult);
                  SET_MEDIA_SELECTION({ media: cropResult.media, on: activeTab });
                })
                .catch(err => {
                  console.error(err);
                  this.setSelection(media.id, activeTab);
                });
            }
            SET_MEDIA_CROP({});
          })
          .catch(err => {
            console.error(err);
          });
      }
      return;
    }

    const newMedia = Number.isNaN(parseInt(this.props.selection.media.id, 10));
    if (newMedia) {
      const {
        selection: { media: selectedMedia }, business_id, UPLOAD_MEDIA,
      } = this.props;

      const {
        url: web_url,
      } = selectedMedia;
      UPLOAD_MEDIA({
        body: {
          business_id, web_url,
        },
        media: selectedMedia,
        from: activeTab,
      }, galleryState.get('imageField'));
    } else {
      const croppedImage = await this.setDefaultCrop(this.props.selection.media);
      this.updateInfo(croppedImage);
      this.props.SET_GALLERY_STATE({ active: false });
    }
  }

  onCrop = image => {
    const { activeTab, SET_MEDIA_CROP } = this.props;
    SET_MEDIA_CROP({
      image,
      on: activeTab,
      rate: MediaGalleryConstants.CROP_RATE.Campaign,
    });
  }

  onScrollWebMedias = e => {
    const el = e.target;
    const { scrollTop, clientHeight, scrollHeight } = el;
    if (scrollTop + clientHeight === scrollHeight) {
      this.searchWebMedias(this.state.web_media_query, this.props.web_media_page);
    }
  }

  onCropTemplateClick = ({ currentTarget: { dataset } }) => {
    const { crop, SET_MEDIA_CROP } = this.props;
    const { croprate } = dataset;
    SET_MEDIA_CROP({ ...crop, rate: MediaGalleryConstants.CROP_RATE[croprate] });
  }

  onSearchSubmit = query => {
    this.setState({ web_media_query: query });
    this.searchWebMedias(query, 1);
  }

  setDefaultCrop = async media => {
    const { galleryState } = this.props;
    const cropRate = MediaGalleryConstants.CONTEXT_CROP_RATE[galleryState.get('imageField')];
    if (media.type !== MediaGalleryConstants.MEDIA_TYPE.image || !cropRate) {
      return media;
    }
    // console.log('DEFAULT CROP', media);
    const image = { ...media };
    if (!image.url) {
      image.url = image.twokey_url || image.web_url;
    }
    let imgMeta = { ...media };
    if (!imgMeta.width || !imgMeta.height) {
      imgMeta = await getImageMeta(image.url);
    }
    // string.charAt(0).toUpperCase() + string.slice(1)
    // console.log('META', imgMeta, cropRate, imgMeta.width / cropRate >= imgMeta.height);
    if (imgMeta.width / cropRate <= imgMeta.height) {
      // console.log('WIDTH GTE HEIGHT');
      image.x1 = 0;
      image.x2 = imgMeta.width;
      const cropHeight = imgMeta.width / cropRate;
      image.y1 = (imgMeta.height - cropHeight) / 2;
      image.y2 = image.y1 + cropHeight;
    } else {
      // console.log('WIDTH LTE HEIGHT');
      image.y1 = 0;
      image.y2 = imgMeta.height;
      const cropWidth = imgMeta.height * cropRate;
      image.x1 = (imgMeta.width - cropWidth) / 2;
      image.x2 = image.x1 + cropWidth;
    }
    // console.log('CROPPED', image, this.cropper);
    return image;
  }

  setSelection = (mediaId, on) => {
    this.props.SET_MEDIA_SELECTION({ media: this.props.medias.find(m => m.id === mediaId), on });
  }

  handleCrop = debounce(e => {
    // TODO: Implement upload preview
    /*
    console.log('IMAGE', e);
    this.cropper.getCroppedCanvas().toBlob(blob => {
      console.log('CROPPED BLOB', blob);
      const fr = new FileReader();
      fr.onload = () => {
        console.log(fr.result);
      };

      fr.readAsText(blob);
    }, 'image/jpeg', 0.5);
    */
    this.props.SET_MEDIA_CROPPED_IMAGE(e.detail);
    // console.log('CROP', e, this.cropper.getData(true))
  }, 300)

  deleteSelectedMedia = () => {
    const { intl: { formatMessage }, selection: { media, on }, activeTab } = this.props;
    if (!media || on !== activeTab) return;

    swal.fire({
      title: formatMessage(
        { id: 'media.delete_type', defaultMessage: '!Delete This {type}?' },
        { type: media.type }
      ),
      showCancelButton: true,
      confirmButtonText: formatMessage({ id: 'main.yes', defaultMessage: '!Yes' }),
      cancelButtonText: formatMessage({ id: 'main.cancel', defaultMessage: '!Cancel' }),
      confirmButtonClass: 'btn swal confirm',
      cancelButtonClass: 'btn swal cancel',
      customClass: 'border-green',
    }).then(res => {
      if (res.value) {
        if (media.isTemporary) {
          this.props.REMOVE_MEDIA(media.id, activeTab);
        } else {
          this.props.DELETE_MEDIA(media.id, activeTab);
        }
      }
    });
  }

  searchWebMedias = (query, page) => {
    this.props.SEARCH_WEB_MEDIAS({ q: query, page });
  }

  refCropper = c => {
    this.cropper = c;
  }

  refSearchInput = e => {
    this.searchInput = e;
  }

  checkIsSelectionAllowed = item => {
    const {
      crop, activeTab, galleryState,
    } = this.props;
    return galleryState.get('isCropMode') || (crop && crop.on === activeTab)
      || (MediaGalleryConstants.ALLOWED_MEDIA_TYPES[galleryState.get('imageField')]
      && item && MediaGalleryConstants.ALLOWED_MEDIA_TYPES[galleryState.get('imageField')].includes(item.type));
  }

  updateInfo = image => {
    const {
      UPDATE_CAMPAIGN_FORM_FIELD, galleryState, onConfirm, CHANGE_FORM, UPDATE_BUSINESS_INFO, business_id,
    } = this.props;

    const campaignImgArray = ImageInterface.map(key => ({
      key: `${ImageFields[galleryState.get('imageField')]}_${key}`, value: image[key],
    }));
    const businessImgObject = {
      business_id,
      profile_media_id: image.id,
      profile_media_type: image.type,
      profile_media_url: image.url || image.twokey_url,
      profile_x1: image.x1,
      profile_x2: image.x2,
      profile_y1: image.y1,
      profile_y2: image.y2,
    };

    switch (galleryState.get('type')) {
    case 'create_form':
      UPDATE_CAMPAIGN_FORM_FIELD(campaignImgArray);
      break;
    case 'create_token':
      CHANGE_FORM('createERC20Token', 'token_media_id', image.id);
      CHANGE_FORM('createERC20Token', 'tokenImage', image);
      break;
    case 'editor':
    case 'business':
      if (onConfirm) onConfirm(image);
      break;
    case 'business-profile':
      UPDATE_BUSINESS_INFO(businessImgObject);
      break;
    default:
      break;
    }
  }

  render() {
    const {
      intl: { formatMessage }, medias = [], /* web_media_query,*/ SET_MEDIA_TAB, galleryState, parent,
      activeTab, crop, selection, uploading, isOpen, isMobile, uploadingCropped, // imageField,
    } = this.props;

    return (
      <Modal
        className="modal-trans media-gallery"
        isOpen={isOpen && parent === galleryState.get('parent')}
        onRequestClose={this.onCancel}
        closeTimeoutMS={100}
        shouldCloseOnOverlayClick
      >
        {isMobile
          ? (
            <div className="modal-container middle mobile-container">
              <div className="modal-content text-center flex flex-column vCenter">
                <img src={NoMobile} alt="no_mobile.svg" className="mb-20" />
                <div className="mb-20">
                  <FormattedMessage
                    id="media.mobile.notice"
                    defaultMessage="!This functional is not available in mobile.{br} Check it out from desktop"
                    values={{ br: <br /> }}
                  />
                </div>
                <Button
                  title={formatMessage({ id: 'media.close', defaultMessage: '!Close' })}
                  onClick={this.onCancel}
                />
              </div>
            </div>
          )
          : (
            <div className="modal-container middle" id="mediaGallery">
              <div className="modal-content">
                <Tabs className="media" activeKey={activeTab || 1} onSelect={SET_MEDIA_TAB}>
                  {!crop || !crop.image || crop.on === 1 ? (
                    <Tab eventKey={1} title={formatMessage({ id: 'media.gallery' })}>
                      {crop.on === activeTab
                        ? <ImageCropper onCrop={this.handleCrop} refCropper={this.refCropper} crop={crop} />
                        : (
                          <ViewBody hide={crop.on === activeTab}>
                            <MyMedias
                              media={selection.on === activeTab ? selection.media : null}
                              imageField={galleryState.get('imageField')}
                              onCrop={this.onCrop}
                              checkIsSelectionAllowed={this.checkIsSelectionAllowed}
                            />
                          </ViewBody>
                        )}
                    </Tab>
                  ) : null}
                  {medias.length && !galleryState.get('isCropMode') && (!crop || !crop.image || crop.on === 2) ? (
                    <Tab eventKey={2} title={formatMessage({ id: 'media.website' })}>
                      {crop.on === activeTab
                        ? <ImageCropper onCrop={this.handleCrop} refCropper={this.refCropper} crop={crop} />
                        : (
                          <ViewBody hide={crop.on === activeTab}>
                            <HostedMedias
                              media={selection.on === activeTab ? selection.media : null}
                              onCrop={this.onCrop}
                              checkIsSelectionAllowed={this.checkIsSelectionAllowed}
                            />
                          </ViewBody>
                        )}
                    </Tab>
                  ) : null}
                  {!galleryState.get('isCropMode') && (!crop || !crop.image || crop.on === 3) && (
                    <Tab
                      eventKey={3}
                      title={formatMessage({ id: 'media.search', defaultMessage: '!Search Web' })}
                      selectedExtraEl={!(crop && crop.on === 3) && (
                        <div style={{ marginTop: 5 }}>
                          {/* <SearchInput
                          value={web_media_query}
                          data-page={1}
                          onSubmit={this.onSearchSubmit}
                          submitOnEmpty
                        /> */}
                          <div className="search-input-container">
                            <div className="search-input-icon"><i className="fa fa-search" /></div>
                            <input
                              ref={this.refSearchInput}
                              type="text"
                              value={this.state.searchInputValue}
                              onKeyDown={this.onKeyDownSearchInput}
                              onBlur={this.onBlurSearchInput}
                              onChange={this.onChangeSearchInput}
                            />
                          </div>
                        </div>
                      )}
                    >
                      {crop.on === activeTab
                        ? <ImageCropper onCrop={this.handleCrop} refCropper={this.refCropper} crop={crop} />
                        : (
                          <ViewBody hide={crop.on === activeTab}>
                            <WebMedias
                              media={selection.on === activeTab ? selection.media : null}
                              onCrop={this.onCrop}
                              onScroll={this.onScrollWebMedias}
                              checkIsSelectionAllowed={this.checkIsSelectionAllowed}
                            />
                          </ViewBody>
                        )}
                    </Tab>
                  )}
                </Tabs>
                <Footer
                  uploading={uploading || uploadingCropped}
                  activeTab={activeTab}
                  crop={crop}
                  selection={selection}
                  forbiddenType={!this.checkIsSelectionAllowed(selection && selection.media)}
                  deleteSelectedMedia={this.deleteSelectedMedia}
                  onCropTemplateClick={this.onCropTemplateClick}
                  onCancel={this.onCancel}
                  onConfirm={this.onConfirm}
                />
              </div>
            </div>
          )}
      </Modal>
    );
  }
}

const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(MediaGalleryModal);

export default injectIntl(connectedComponent);
